import { render, staticRenderFns } from "./PdvReverseAuthorization.vue?vue&type=template&id=22af9a2f"
import script from "./PdvReverseAuthorization.vue?vue&type=script&lang=js"
export * from "./PdvReverseAuthorization.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports